import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/fireworks.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-4461a02f")

_pushScopeId("data-v-4461a02f")
const _hoisted_1 = {
  class: "container products-page",
  id: "products"
}
const _hoisted_2 = { class: "main-reverse-page-title" }
const _hoisted_3 = { class: "d-lg-flex" }
const _hoisted_4 = { class: "products-actions order-lg-1 col-lg-2 mb-lg-0 justify-content-center justify-content-lg-end" }
const _hoisted_5 = { class: "products-search col-lg-5 mt-auto" }
const _hoisted_6 = { class: "search-button-wrapper pl-15" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-search fs-24" }, null, -1)
const _hoisted_8 = { class: "products-total-filter col-lg-5 mt-auto px-lg-2" }
const _hoisted_9 = {
  class: "products-total order-lg-1",
  style: {"height":"48px"}
}
const _hoisted_10 = { class: "show-all-clear-filter align-items-lg-center" }
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-filter fs-24 pl7" }, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "products-filter-circle"
}
const _hoisted_13 = { class: "order-4 d-flex" }
const _hoisted_14 = { class: "data-to-row" }
const _hoisted_15 = { class: "product-details-title" }
const _hoisted_16 = {
  key: 0,
  class: "desktop-grid w100"
}
const _hoisted_17 = { class: "w100" }
const _hoisted_18 = { class: "thead-cell-center" }
const _hoisted_19 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_20 = { class: "thead-cell-center" }
const _hoisted_21 = { class: "desktop-table-action" }
const _hoisted_22 = { class: "thead-cell-end" }
const _hoisted_23 = { class: "desktop-table-text-setting" }
const _hoisted_24 = { class: "desktop-table-text-setting" }
const _hoisted_25 = {
  class: "desktop-table-text-setting",
  style: {"width":"25%"}
}
const _hoisted_26 = { class: "desktop-table-text-setting" }
const _hoisted_27 = { class: "desktop-table-text-setting" }
const _hoisted_28 = {
  class: "text-center",
  style: {"position":"relative"}
}
const _hoisted_29 = { class: "warning-info-text" }
const _hoisted_30 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-info-solid fs-20" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("span", { class: "mx-1" }, null, -1)
const _hoisted_32 = {
  class: "desktop-table-text-setting text-center",
  style: {"padding-inline-start":"14px"}
}
const _hoisted_33 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-export fs-18" }, null, -1)
const _hoisted_34 = { class: "desktop-table-action text-end" }
const _hoisted_35 = {
  key: 1,
  class: "mobile-grid"
}
const _hoisted_36 = { class: "header-line" }
const _hoisted_37 = { class: "not-active-title-wrapper" }
const _hoisted_38 = {
  key: 0,
  class: "not-active-title"
}
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_40 = { class: "mobile-table-info-card" }
const _hoisted_41 = { class: "details-row" }
const _hoisted_42 = { class: "details-row" }
const _hoisted_43 = { class: "product-actions text-end" }
const _hoisted_44 = {
  key: 2,
  class: "col-12 no-products-content"
}
const _hoisted_45 = { class: "step-done-wrapper" }
const _hoisted_46 = {
  class: "done-title",
  style: {"margin-bottom":"30px"}
}
const _hoisted_47 = /*#__PURE__*/_createVNode("div", {
  class: "done-image",
  style: {"margin-bottom":"40px"}
}, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_48 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_49 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus-circle fs-26 browse-icon" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('navbar.catalog')), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("button", {
          type: "button",
          class: "product-circle-btn btn-green mx-1",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.GoCreateProductStepOne()))
        }, _toDisplayString(_ctx.$t('button.newProduct')), 1)
      ]),
      _createVNode("div", _hoisted_5, [
        _withDirectives(_createVNode("input", {
          class: "bookit-input provider-input w100",
          type: "text",
          placeholder: _ctx.$t('placeholder.searchByOptionName'),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter.keyword = $event)),
          onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.getProducts()), ["enter"]))
        }, null, 40, ["placeholder"]), [
          [_vModelText, _ctx.filter.keyword]
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("button", {
            type: "button",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getProducts()))
          }, [
            _hoisted_7
          ])
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("div", null, _toDisplayString(_ctx.$t('products.totalProducts')) + ":", 1),
          _createVNode("div", null, _toDisplayString(_ctx.products.length) + " " + _toDisplayString(_ctx.$t('documents.ofProds', { total: _ctx.productTotal })), 1)
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("span", {
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showAll && _ctx.showAll(...args)))
          }, _toDisplayString(_ctx.$t('button.showAll')), 1)
        ]),
        _createVNode("div", {
          class: ["products-filter", { hasFilter: _ctx.hasFilter }]
        }, [
          _createVNode("button", {
            type: "button",
            class: "products-filter-btn-text",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.ShowFilter && _ctx.ShowFilter(...args)))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('button.filters')) + " ", 1),
            _hoisted_11
          ]),
          (_ctx.hasFilter)
            ? (_openBlock(), _createBlock("div", _hoisted_12, "!"))
            : _createCommentVNode("", true)
        ], 2),
        _createVNode("div", _hoisted_13, [
          _createVNode("span", _hoisted_14, [
            _createVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('product.active')) + ":", 1),
            _withDirectives(_createVNode("input", {
              type: "checkbox",
              class: "toggle",
              checked: _ctx.showOnlyActiveProducts,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.showOnlyActiveProducts = $event)),
              onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.showOnlyActiveProducts = !_ctx.showOnlyActiveProducts, _ctx.getProducts()), ["stop"]))
            }, null, 8, ["checked"]), [
              [_vModelCheckbox, _ctx.showOnlyActiveProducts]
            ])
          ])
        ])
      ])
    ]),
    (_ctx.productTotal > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_16, [
          _createVNode("table", _hoisted_17, [
            _createVNode("thead", null, [
              _createVNode("tr", null, [
                _createVNode("td", {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sortBothWay('Id')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('catalog.productId')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Id')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", null, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('catalog.productHashId')), 1)
                ]),
                _createVNode("td", {
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sortBothWay('Name')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('product.productName')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Name')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sortBothWay('Type')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('product.productType')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Type')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", null, [
                  _createVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('catalog.calendarColor')), 1)
                ]),
                _hoisted_19,
                _createVNode("td", null, [
                  _createVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('catalog.b2cLink')), 1)
                ]),
                _createVNode("td", _hoisted_21, [
                  _createVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('customerType.actions')), 1)
                ])
              ])
            ]),
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.products, (product, index) => {
                return (_openBlock(), _createBlock("tr", {
                  class: product.active === false ? 'deactivated-marker' : '',
                  key: product.idNoHash,
                  style: {"position":"relative"}
                }, [
                  _createVNode("td", _hoisted_23, _toDisplayString(product.idNoHash), 1),
                  _createVNode("td", _hoisted_24, _toDisplayString(product.id), 1),
                  _createVNode("td", _hoisted_25, [
                    _createVNode("span", {
                      class: "text-link cuted-cell m-0",
                      onClick: ($event: any) => (_ctx.routeToProduct(product.id))
                    }, _toDisplayString(product.name), 9, ["onClick"])
                  ]),
                  _createVNode("td", _hoisted_26, _toDisplayString(_ctx.getProductType(product.productTypeId)), 1),
                  _createVNode("td", _hoisted_27, [
                    _createVNode("div", {
                      class: "calendar-circle",
                      style: 'background:' + product.calendarColor
                    }, null, 4)
                  ]),
                  _createVNode("td", _hoisted_28, [
                    (_ctx.anyEmptyMandatoryFields(product))
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: "mandatory-warning-info dp-none",
                          id: 'product-update-' + index
                        }, [
                          _createVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('catalog.mandatoryWarning.updateProduct')), 1)
                        ], 8, ["id"]))
                      : _createCommentVNode("", true),
                    (_ctx.anyEmptyMandatoryFields(product))
                      ? (_openBlock(), _createBlock("span", {
                          key: 1,
                          class: "product-update-mandatory",
                          onMouseleave: ($event: any) => (_ctx.hideWarning(index)),
                          onMouseenter: ($event: any) => (_ctx.showWarning(index)),
                          onClick: ($event: any) => (_ctx.routeToProduct(product.id))
                        }, [
                          _hoisted_30,
                          _hoisted_31,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('catalog.update')), 1)
                        ], 40, ["onMouseleave", "onMouseenter", "onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("td", _hoisted_32, [
                    (product.onAir)
                      ? (_openBlock(), _createBlock("a", {
                          key: 0,
                          style: {"color":"#42aee7"},
                          href: `https://www.bookit.fun/product?productID=${product.id}`,
                          target: "_blank",
                          class: !product.active ? 'link-disabled' : ''
                        }, [
                          _hoisted_33
                        ], 10, ["href"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("td", _hoisted_34, [
                    (product.active)
                      ? (_openBlock(), _createBlock("i", {
                          key: 0,
                          onClick: ($event: any) => (_ctx.createProductCopy(product.id)),
                          class: "icon-f icon-copy fs-16 m-2"
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    _createVNode("i", {
                      onClick: ($event: any) => (_ctx.routeToProduct(product.id)),
                      class: "icon-f icon-pencil-edit fs-16"
                    }, null, 8, ["onClick"])
                  ])
                ], 2))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.productTotal > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_35, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.products, (product, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "product-item",
              onClick: ($event: any) => (_ctx.routeToProduct(product.id)),
              key: index
            }, [
              _createVNode("a", _hoisted_36, [
                _createVNode("span", null, _toDisplayString(product.name), 1),
                _createVNode("span", _hoisted_37, [
                  (!product.active)
                    ? (_openBlock(), _createBlock("div", _hoisted_38, _toDisplayString(_ctx.$t('product.notActive')), 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("span", {
                  class: "calendar-circle",
                  style: 'background:' + product.calendarColor
                }, null, 4)
              ]),
              _hoisted_39,
              _createVNode("div", _hoisted_40, [
                _createVNode("div", _hoisted_41, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('product.productType')) + ": ", 1),
                  _createVNode("span", null, _toDisplayString(_ctx.getProductType(product.productTypeId)), 1)
                ]),
                _createVNode("div", _hoisted_42, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('catalog.productHashId')) + ": ", 1),
                  _createVNode("span", null, _toDisplayString(product.id), 1)
                ])
              ]),
              _createVNode("div", _hoisted_43, [
                _createVNode("i", {
                  onClick: _withModifiers(($event: any) => (_ctx.createProductCopy(product.id)), ["stop"]),
                  class: "icon-f icon-copy fs-20"
                }, null, 8, ["onClick"])
              ])
            ], 8, ["onClick"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.productTotal == 0)
      ? (_openBlock(), _createBlock("div", _hoisted_44, [
          _createVNode("div", _hoisted_45, [
            _createVNode("h3", _hoisted_46, _toDisplayString(_ctx.$t('user.canCreateProductsTitle')), 1),
            _hoisted_47,
            _createVNode("div", _hoisted_48, [
              _createVNode("button", {
                class: "btn browse-photo browse-button green-button",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.GoCreateProductStepOne())),
                style: {"margin":"0 auto"},
                type: "button"
              }, [
                _hoisted_49,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('button.newProduct')), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})